var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSentra(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2847_82019)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2891 0H9.28906V6H24.2891V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 18.0977H0V24.0977H15V18.0977Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 0H0V6H6V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 18H18V24H24V18Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9271 15.3447C13.7443 15.3447 15.2174 13.8475 15.2174 12.0005C15.2174 10.1536 13.7443 8.65625 11.9271 8.65625C10.1099 8.65625 8.63672 10.1536 8.63672 12.0005C8.63672 13.8475 10.1098 15.3447 11.9271 15.3447Z",
    fill: "#F4A72B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 9H0V15H6V9Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 9H18V15H24V9Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2847_82019"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentra);
export default __webpack_public_path__ + "static/media/Sentra.429abe786eedd05baa105c951bfc285c.svg";
export { ForwardRef as ReactComponent };